import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/textLink.module.scss';

import type { AnchorHTMLAttributes } from 'react';
import type { TColorVariant } from '@klv/shared/styles/types';

const TextLink = ({
  $colorVariant = 'dark',
  className,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & { $colorVariant?: TColorVariant; className?: string; }) => (
  <a className={generateClassName([className, styles.textLink, styles[$colorVariant]])} {...props} />
);

export default TextLink;
